import { inject, Injectable } from '@angular/core';
import { AuthActions, ObjectState, UserInitializationService } from '@meddev/fe-shared';
import { Store } from '@ngxs/store';
import { AuthServiceClientService, AuthStateEnum, MCAAuthActions } from '@shared/data';
import { catchError, map, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class McaUserInitializationService extends UserInitializationService {
    private readonly store = inject(Store);
    private readonly authServiceClient = inject(AuthServiceClientService);

    constructor() {
        super();
    }

    initializeUserData() {
        return this.authServiceClient.getUserInfo().pipe(
            switchMap(userInfo => {
                if (!userInfo) {
                    return of(null);
                }

                return this.store.dispatch(new MCAAuthActions.SetUserInfo(userInfo));
            }),
            catchError(() => {
                this.store.dispatch(new MCAAuthActions.SetUserInfo(null));
                return of(null);
            }),
        );
    }

    clearUserData() {
        return this.store.dispatch(new MCAAuthActions.SetUserInfo(null)).pipe(
            switchMap(() => this.store.dispatch(new AuthActions.SetChallenge(null))),
            switchMap(() => this.store.dispatch(new AuthActions.SetChallengeParams(null))),
            switchMap(() => this.store.dispatch(new AuthActions.SetAuthState({ state: ObjectState.VALID, value: AuthStateEnum.CHALLENGE }))),
            map(() => null),
        );
    }
}
